var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"bannerCont"},[_c('img',{attrs:{"src":require("@/mobile/assets/banner/mobile-banner.png"),"alt":""}}),_c('button',{on:{"click":_vm.toDetail}},[_vm._v("了解更多")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }